interface EnhanceWindow extends Window {
  _digy: any[];
  _hmt: any[];
}

declare const window: EnhanceWindow;

/**
  描述：打点通用方法
  参数：
 * @param topkey        - (Str) 三段式打点，topkey
 * @param subkey        - (Str) 三段式打点，subkey
 * @param value         - (Str) 三段式打点，value
  */
const digy = (topkey: string, subkey: string, value: string): void => {
  topkey = topkey || '';
  if (window._digy && topkey) {
    subkey = subkey || '';
    value = value || '';

    if (!subkey || !value) {
      window._digy.push(topkey);
    } else if (subkey) {
      const text =
        topkey + ',' + subkey + ',' + (typeof value === 'object' ? JSON.stringify(value) : value);
      window._digy.push(text);
    }
  }
};

export default digy;
